/** RFC 3842 message-summary bodies (what FreeSWITCH sends for voicemail MWI). */

export interface Voicemail {
  waiting: boolean;
  new: number;
  old: number;
}

/**
 * Parse e.g.
 *   Messages-Waiting: yes
 *   Message-Account: sip:101@pbx.ngn.com.au
 *   Voice-Message: 2/8 (0/0)
 */
export function parseMessageSummary(body: string): Voicemail | null {
  const waiting = /^Messages-Waiting:\s*(yes|no)/im.exec(body);
  if (!waiting) return null;
  const counts = /^Voice-Message:\s*(\d+)\s*\/\s*(\d+)/im.exec(body);
  return {
    waiting: waiting[1].toLowerCase() === 'yes',
    new: counts ? Number(counts[1]) : 0,
    old: counts ? Number(counts[2]) : 0,
  };
}
